// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenToy_text__3cNel","name":"OpenToy_name__1fUEh","contentButton":"OpenToy_contentButton__1nwZF","content":"OpenToy_content__8kI_J"};